import Components from "../components";

class LinearSettings extends Components.Base {
  bind() {
    this.$teamKey = this.$el.find("#channel_team_key")
    this.$teamSelect = this.$el.find("#channel_team_id")
    this.$teamSelect.on("change", this.onTeamSelect.bind(this))
    this.populateTeams(this.$teamSelect.attr("value"));
  }

  onTeamSelect(evt) {
    this.populateTeams(evt.target.value);
  }

  addOption(el, value, text, selected) {
    el.append($('<option>', { value, text, selected }))
  }

  populateTeams(selectedTeamId) {
    this.resetSelect(this.$teamSelect)
    window.linear_config.forEach(team => {
      const teamSelected = selectedTeamId === team.id;
      this.addOption(this.$teamSelect, team.id, team.name, teamSelected)
      if(teamSelected) {
        this.$teamKey.attr("value", team.key)
        this.populateSelects(this.$el.find("#channel_linear_project_id"), team.projects)
        this.populateSelects(this.$el.find("#channel_unresolved_state_id"), team.states)
        this.populateSelects(this.$el.find("#channel_resolved_state_id"), team.states)
        this.populateCheckBoxes("label_ids", this.$el.find(".channel_label_ids"), team.labels)
      }
    })
  }

  resetSelect($el) {
    $el.empty();
    this.addOption($el, "", "")
  }

  populateSelects($el, coll) {
    this.resetSelect($el)

    if(Array.isArray(coll) && !coll.length) {
      $el.prop("disabled", true);
      return;
    }
    $el.prop("disabled", false);
    const selectedId = $el.attr("value")
    coll.forEach(item => {
      this.addOption($el, item.id, item.name, selectedId === item.id);
    })
  }

  populateCheckBoxes(name, $el, coll) {
    $el.find("span").remove();
    const checked = $el.prev().attr("value");
    coll.forEach(item => {
      const wrapper = $('<span class="checkbox form-check">');
      const id = `channel_${name}_${item.id}`;
      $el.append(wrapper);
      wrapper.append($('<input>', { id,
        class: "form-check-input check_boxes optional",
        type: "checkbox",
        name: `channel[${name}][]`,
        checked: (checked !== undefined) ? checked.includes(item.id) : false,
        value: item.id
      }))

      if(item.color !== undefined) {
        wrapper.append($('<label>', {
          for: id,
          class: "form-checkbox-color-label",
          style: `background-color: ${item.color}`
        }))
      }

      wrapper.append($('<label>', {
        class: "form-check-label collection_check_boxes",
        for: id
      }).append(item.name))
    })
  }
}

Components.collection.register({
  selector: 'form[data-kind=linear]',
  klass: LinearSettings,
});
